import styled from 'styled-components'

export const FormStartupOuterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  padding-top: 1px;
  padding-bottom: 1px;
`

export const LeftSideCol = styled.div`
  className: column;
  text-align: left;
  padding: 10px;
`

export const RightSideInnerDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  margin-left: 2%;
`

export const HeaderText = styled.label`
  font-size: 14px;
  color: #0066B3;
  border-radius: 10px;
  padding: 5px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-color: #E5D5FF;
  border: solid 1px;
  background-color: #E5D5FF;
`

export const LeftSideInnerDiv = styled.div`
  width: 60%;
  height: 400px;
  border: solid 1px;
  border-color: #0066B3; 
  border-radius: 10px;
  position: relative;
`

export const LeftSideLabel = styled.label`
  font-size: 14px;
  color: #0066B3;
`

export const NormalLabel = styled.label`
  font-size: 14px;
  display: block;
  margin-bottom: 0.5rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
`

export const NormalLabelB = styled.label`
  font-size: 14px;
  display: block;
  margin-bottom: 0.5rem;
`

export const FormStartupSections = styled.div`
  padding-top: 0.5rem;
  height: 100%;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
`

export const FormStartupHeader = styled.div`
  box-shadow: 0 5px 2px -2px var(--shadow-smooth);
  align-items: center;
  background-color: var(--white);
  min-height: 50px;
  display: flex;
`
export const SidebarWrapper = styled.div`
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 24px 20px;

  @media (max-width: 1205px) {
    display: flex;
    flex-direction: row;
    padding: 0 0 0 0;
    gap: 0;
    background: #F4F2F2;
    border-radius: 0;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #c4c5c6;
  }
`

export const SidebarItem = styled.button<{ $isActive: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 4px 0 8px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: ${props => (props.$isActive ? 700 : 500)};
  color: ${props => (props.$isActive ? '#00599C' : '#4B5563')};
  cursor: pointer;
  border-bottom: ${props => (props.$isActive ? '2px solid #00599C' : '2px solid transparent')};

  &:last-child {
    margin-bottom: 0;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 1205px) {
    flex: 1;
    text-align: center;
    padding: 12px 4px;
    margin-bottom: 0;
    font-size: 15px;
    border-bottom: ${props => (props.$isActive ? '2px solid #00599C' : '2px solid transparent')};
  }
`

export const EcosystemSubtitle = styled.p`
  font-family: 'Caixa Std';
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  margin-top: 4px;
  margin-bottom: 0;
`

export const EcosystemPageHeader = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 0;
`

export const EcosystemPageHeaderLeft = styled.div<{ $hasExportAction?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  padding-right: ${props => (props.$hasExportAction ? '130px' : '0')};

  @media (max-width: 767px) {
    padding-right: ${props => (props.$hasExportAction ? '100px' : '0')};
  }
`

export const EcosystemPageHeaderActions = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`